<app-client-selector (onSelect)="onSelectClient($event)"></app-client-selector>
